const URLCONSTANTS = {
    GET_CUSTOM_FORM_FIELDS_ENDPOINT: "Service/psrformfields",
    GET_SERVICE_USER_PORTFOLIO_ENDPOINT: "Service/serviceuserportfolio",
    POST_PLACE_CALL_SERVICE: "Service/postplacecallservice",
    POLL_GET_PSR_STATUS:"Service/getpsrstatus"
};

export default URLCONSTANTS;